import * as z from 'zod';

export const UpdateHookupValidationSchema = z.object({
  firstParticipant: z.string().min(1),
  secondParticipant: z.string().nullable().optional(),
  startDateTime: z.string().min(1)
});

export type UpdateHookupValidationSchemaType = z.infer<typeof UpdateHookupValidationSchema>;
